import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stock-config",
  "use": "icon-stock-config-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stock-config\"><defs><style type=\"text/css\"></style></defs><path d=\"M341.333333 227.555556H227.555556V56.888889H170.666667v170.666667H56.888889v227.555555h113.777778v512h56.888889V455.111111h113.777777V227.555556zM284.444444 398.222222H113.777778V284.444444h170.666666v113.777778zM796.444444 227.555556V56.888889h-56.888888v170.666667h-113.777778v227.555555h113.777778v512h56.888888V455.111111h113.777778V227.555556h-113.777778z m56.888889 170.666666h-170.666666V284.444444h170.666666v113.777778zM512 56.888889H455.111111v512H341.333333v227.555555h113.777778v170.666667h56.888889v-170.666667h113.777778v-227.555555H512V56.888889z m56.888889 568.888889v113.777778H398.222222v-113.777778h170.666667z\" p-id=\"2552\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/stock-config.svg
// module id = K+n/
// module chunks = 7